import { useQuery } from "react-query";
import constants from "../../../utils/constants";
import servicesUtils from "../../../utils/servicesUtils";
import { transformPermittedUsers } from "../transformers/transformPermittedUsers";
export var useWorkspacePermittedUsers = function useWorkspacePermittedUsers() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var permission = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants.WORKSPACE_USER_ROLES.WORKSPACE_TASK_ASSIGNABLE;
  var fetchFunction = function fetchFunction() {
    if (!id) throw new Error("Workspace ID is required");
    return servicesUtils.getService("/workspaces/".concat(id, "/get_permitted_accounts/?permission=").concat(permission)).then(function (data) {
      return {
        users: transformPermittedUsers(data)
      };
    });
  };
  return useQuery(["permittedWorkspaceUsers", id], fetchFunction, {
    enabled: id !== null
  });
};